import { Alert } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import { selectContractDetails } from '../../redux/selectors/contracts.selector';
import { useEffect, useState } from 'react';
import { PaymentMethodType, contractTypes } from '../../service/common';
import { PayNowType } from '../../types';

interface PaymentNoteProps {
  selected_modal_type?: PayNowType | null,
  is_overdue?: boolean
}

export const PaymentNote = ({ selected_modal_type, is_overdue }: PaymentNoteProps) => {

  const [transactionAmountData, setTransactionAmountData] = useState<{
    non_us_amount_below_threshold: number,
    non_us_percent_above_threshold: number
  }>();

  const { transactionFeeMetrics, selectedContractDetails } = useSelector((state: RootState) => selectContractDetails(state));

  useEffect(() => {
    let thresholdData = (transactionFeeMetrics as any)[contractTypes.SECURE_MUTUAL + '_' + contractTypes.MAX_MUTUAL];

    // eslint-disable-next-line eqeqeq
    let findItem = thresholdData.find((item: any) => item.source_type_id == PaymentMethodType.CARD);
    if (findItem && findItem.source_type_id) {
      setTransactionAmountData({
        non_us_amount_below_threshold: findItem?.non_us_amount_below_threshold,
        non_us_percent_above_threshold: findItem?.non_us_percent_above_threshold
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <Alert variant="" className="p-0">
      <h5 className="fs-12 fw-600 text-secondary mt-3">Notes</h5>
      <ul>
        {/* <li className="fs-12 fw-500 text-muted mb-2">
        <strong>$3.00</strong> transaction charges will be
        charged separately for the partial payment.
        </li> */}
        <li className="fs-12 fw-500 text-muted mb-2">
          You will be charged <strong>${transactionAmountData?.non_us_amount_below_threshold}</strong> or <strong>{transactionAmountData?.non_us_percent_above_threshold}%</strong> (whichever is higher) as an extra
          fee if you use a non-US debit/credit card.
        </li>
        {selected_modal_type === PayNowType.PARTIAL && selectedContractDetails?.partial_payment_logic_setting ? (
          <>
          <li className="fs-12 fw-400 grey-106 mb-2 lh-2" >
          A transaction fee of 3% or $3 (whichever is higher) will be applied to the transaction amount.
            </li >
            <li className="fs-12 fw-400 grey-106 mb-2 lh-2" >
              Partial payment will be adjusted against the upcoming recurring payment, and the recurring date will be updated accordingly.
            </li >
            {selectedContractDetails?.pf_status === 3 && selectedContractDetails.missing_payments > 0 && (
              <li className="fs-12 fw-400 grey-106 mb-2 lh-2">
                A late fee of $25 will also be adjusted from the partial payment. Late fee is applied to each overdue recurring payment.
              </li>
            )}
          </>
        ) : <></>}
        {selected_modal_type === PayNowType.PARTIAL && selectedContractDetails?.partial_payment_logic_setting === 0? (
          <>
            <li className="fs-12 fw-400 grey-106 mb-2 lh-2" >
            Partial payment will reduce the total remaining balance and your monthly installment amount.
            </li >
          </>
        ) : <></>}
        {selected_modal_type === PayNowType.CHANGE_PAYMENT_DATE && <li className="fs-12 fw-400 grey-106 mb-2 lh-2">
          It will not reduce the number of payments remaining and
          will not change the due date of the next payment.
        </li>}
      </ul>
    </Alert>
  )
}
